/**
 * «Время записи» сотрудника: загрузка салона по часам на 14 дней, автоподбор самых свободных
 * часов и текст клиенту. Время — местное салона. Спека `docs/specs/2026-10-05-zapis-time-design.md`.
 */
import { apiFetch } from "@/lib/api";

/** `peak` — пик выходных (сб/вс 12–16): по регламенту не записываем и при зелёном проценте. */
export type SlotLevel = "ok" | "orange" | "red" | "peak" | "none";
export type SlotHour = {
  hour: number;
  level: SlotLevel;
  /** Час уже начался. */
  past: boolean;
  load: number | null;
  /** Уже записано примерок. */
  cur: number | null;
  /** Сколько ещё можно записать с запасом / максимум. */
  free: number | null;
  max: number | null;
  stylists: number | null;
  /** Стилисты по среднему графику (не текущая неделя) — оценка, не факт. */
  estimate: boolean;
};
export type SlotDay = { date: string; estimate: boolean; hours: SlotHour[] };
/** День `ГГГГ-ММ-ДД` → часы прихода, отмеченные в рекомендацию. */
export type Picked = Record<string, number[]>;
export type SlotLocation = { id: number; name: string; short: string };
export type SlotPage = {
  location: SlotLocation;
  locations: SlotLocation[];
  /** Местное «сейчас» салона `ГГГГ-ММ-ДДTЧЧ:ММ`. */
  now: string;
  days: SlotDay[];
  /** Дни дальше окна до последнего дня со слотами: часы без расчёта загрузки (`none`) — их
   *  открывают календарём. Сервера без поля не осталось, но панель расширения переживёт и его. */
  far?: SlotDay[];
  /** Автоподбор по умолчанию: ближайшие дни со свободными часами. */
  picked: Picked;
  text: string;
  /** Рекомендованные часы каждого дня окна — подставляются, когда сотрудник отметил день сам. */
  suggest: Picked;
  /** Начало сообщения клиенту до ссылки на самозапись. */
  invite: string;
};

export const loadSlots = (location: number | null) =>
  apiFetch<SlotPage>(`/api/zapis/slots${location ? `?location=${location}` : ""}`);
/** Абзац с рекомендованным временем по отметкам — предпросмотр, ничего не пишет. */
export const loadSlotsText = (location: number, picked: Picked) =>
  apiFetch<{ text: string }>("/api/zapis/slots/text", { method: "POST", body: JSON.stringify({ location, picked }) });
